import React from 'react';
import './SizeSelector.css';

const SIZES = [
  { value: 100, label: '100g' },
  { value: 200, label: '200g' },
  { value: 500, label: '500g' },
];

function SizeSelector({ selected, onChange, cupsBySize }) {
  return (
    <div className="size-selector">
      {SIZES.map((size) => {
        const cups = cupsBySize ? cupsBySize[size.value] : null;
        return (
          <button
            key={size.value}
            type="button"
            className={`size-option ${selected === size.value ? 'selected' : ''}`}
            onClick={() => onChange(size.value)}
            aria-pressed={selected === size.value}
          >
            <span className="size-label">{size.label}</span>
            {cups != null && (
              <span className="size-cups">~{cups} cups</span>
            )}
          </button>
        );
      })}
    </div>
  );
}

export default SizeSelector;
